class EnhancedGallery {
  constructor(element) {
    this.element = element;
    this.currentIndex = 0;
    this.track = element.querySelector('.gallery-track');
    this.slides = element.querySelectorAll('.gallery-slide');
    this.totalSlides = this.slides.length;

    this.init();
  }

  init() {
    // Arrow navigation
    const prevBtn = this.element.querySelector('.gallery-arrow--prev');
    const nextBtn = this.element.querySelector('.gallery-arrow--next');

    if (prevBtn) prevBtn.addEventListener('click', () => this.goToPrevious());
    if (nextBtn) nextBtn.addEventListener('click', () => this.goToNext());

    // Thumbnail navigation
    const thumbnails = this.element.querySelectorAll('.thumbnail-button');
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.goToSlide(index));
    });

    // Touch/swipe support
    this.addSwipeSupport();
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.updateGallery();
  }

  goToPrevious() {
    this.currentIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
    this.updateGallery();
  }

  goToNext() {
    this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
    this.updateGallery();
  }

  updateGallery() {
    // Update slide position
    if (this.track) {
      this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
    }

    // Update active states
    this.updateActiveStates();

    // Update counter
    this.updateCounter();
  }

  updateActiveStates() {
    // Update slides
    this.slides.forEach((slide, index) => {
      slide.classList.toggle('active', index === this.currentIndex);
    });

    // Update thumbnails
    const thumbnails = this.element.querySelectorAll('.thumbnail-button');
    thumbnails.forEach((thumb, index) => {
      thumb.classList.toggle('active', index === this.currentIndex);
    });

    // Update scroll segments (fill up to current index)
    const segments = this.element.querySelectorAll('.scroll-segment');
    segments.forEach((segment, index) => {
      segment.classList.toggle('active', index <= this.currentIndex);
    });
  }

  updateCounter() {
    const currentSlideEl = this.element.querySelector('.current-slide');
    if (currentSlideEl) {
      currentSlideEl.textContent = this.currentIndex + 1;
    }
  }

  addSwipeSupport() {
    let startX = 0;
    let endX = 0;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    });

    this.track.addEventListener('touchmove', (e) => {
      endX = e.touches[0].clientX;
    });

    this.track.addEventListener('touchend', () => {
      const diff = startX - endX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.goToNext();
        } else {
          this.goToPrevious();
        }
      }
    });
  }
}

// Initialize all galleries on the page
function initializeEnhancedGalleries() {
  const galleries = document.querySelectorAll('.enhanced-gallery');
  galleries.forEach((gallery) => {
    // Destroy existing instance if it exists
    if (gallery.galleryInstance) {
      gallery.galleryInstance = null;
    }
    // Create new instance
    gallery.galleryInstance = new EnhancedGallery(gallery);
  });
}

// Initialize on DOM ready - handles both already-loaded and still-loading states
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeEnhancedGalleries();
  });
} else {
  // DOM is already loaded, initialize immediately
  initializeEnhancedGalleries();
}

// Listen for gallery updates from DMO system
window.addEventListener('enhanced-gallery-update', () => {
  setTimeout(() => {
    initializeEnhancedGalleries();
  }, 100);
});

// Expose class globally for DMO system
window.EnhancedGallery = EnhancedGallery;
